import { defineMessages } from "react-intl";
const messages = defineMessages({
    imageUploaderUploadTitle: {
        id: "app.commmon.components.imageUploader.imageUploadTitle.text",
        defaultMessage: "Drag and drop your image or upload from your computer.",
    },
    imageUploaderUpdateTitle: {
        id: "app.commmon.components.imageUploader.buildingLogoUpdateTitle.text",
        defaultMessage: "Click here to change image.",
    },
    imageUploaderUploadDescription: {
        id: "app.commmon.components.imageUploader.imageUploadDescription.text",
        defaultMessage: "Upload an image less than 3 MB in JPG/JPEG format!",
    },
    imageUploaderUploadMaxFileSizeError: {
        id: "app.commmon.components.imageUploader.imageUploadMaxFileSizeError.text",
        defaultMessage: "Please upload an image less than 3 MB.",
    },
    imageUploaderUploadAccestTypeError: {
        id: "app.commmon.components.imageUploader.imageUploadAccestTypeError.text",
        defaultMessage: "Please upload an image in JPG/JPEG format.",
    },
});
export default messages;
